import { TStandingType } from '../../../../../../store/admin/eventAwards/store';
import { IUserAwards } from '../../../../../../store/admin/roundFormatAwards/store';

import { getUserAwards } from './getUserAwards';

export const getUserAwardField = (
  userId: number,
  field: TStandingType,
  userAwards: IUserAwards,
  awardsToUpdate: IUserAwards,
  isAHoleLeaderboard?: boolean,
  hole?: number
) => {
  const allUserAward = getUserAwards(userId, userAwards, awardsToUpdate) || [];

  const userAward =
    isAHoleLeaderboard && hole
      ? allUserAward.find(
          award => award.hole !== null && award.hole !== undefined && award.hole === Number(hole)
        )
      : allUserAward[0];

  return userAward ? userAward[field] : null;
};
